export default "__VITE_ASSET__54eb9442__"